// import { useNavigate } from 'react-router-dom';

// export function withNavigation(Component) {
//   return (props) => <Component {...props} navigate={useNavigate()} />;
// }

import { useLocation, useNavigate, useParams } from "react-router-dom";

export function withNavigation(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}
